export default __webpack_public_path__ + "static/media/kal_ble.e232745f.jpg";